import _ from 'underscore';
import LocationService from 'views/utils/LeafletMap/MapServices/LocationService';

var GoogleLocationService = function(args) {
    LocationService.apply(this, args);

    this.geocoder = new google.maps.Geocoder();

    return this;
};

GoogleLocationService.prototype = Object.create(LocationService.prototype);
GoogleLocationService.prototype.constructor = GoogleLocationService;

GoogleLocationService.prototype.fetch = function fetch(options, context) {
    this.geocoder.geocode({ address: options.address }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
            options.success.call(context, {
                address: options.address,
                location: [results[0].geometry.location.lat(), results[0].geometry.location.lng()]
            });
        } else {
            options.error.call(context, 'Error finding address', status);
        }
    });
};

export default GoogleLocationService;
